// extracted by mini-css-extract-plugin
export var menuIcon = "_px-0";
export var menuIconInline = "_px-1";